import React from 'react';
import useTitle from '../../hooks/useTitle';

const TermsConditions = () => {
  useTitle('TermsConditions');

  return (
    <div className='my-12 shadow-2xl'>
      <h1 className='text-center text-2xl'>Terms and Conditions</h1>
      <div className='m-5 p-5'>
        <div className='m-2 p-2'>
          <h2 className='text-xl'>GAP Free Terms</h2>
          <p className='mt-3'>
            ✔ The Scale and Clean does not include a second visit for the
            treatment, the use of anaesthesia, deep clean, periodontal charting{' '}
            <br />✔ OPG’s and Lateral Ceph’s are not covered under the Gap Free
            Treatment that we provide, unless the dentist states otherwise{' '}
            <br />
            ✔ This package is available once in a six month period <br />✔
            Health Fund cards must be present on day of treatment or full price
            will have to be paid and patient will have to claim for themselves
          </p>
        </div>
        <div className='m-2 p-2'>
          <h2 className='text-xl'>Other Terms</h2>
          <p className='mt-3'>
            ✔ Any surgical or invasive procedure carries risks. Before
            proceeding, you should seek a second opinion from an appropriately
            qualified health practitioner. <br />
            ✔ No person should rely on the contents of any of the information,
            products or services on this website without first obtaining advice
            from a qualified professional person. No person should act on any
            information, products or services provided before they have formed
            their own opinion through investigation and research as to the
            suitability of the information, products or services for their
            circumstances. <br />
            ✔ While every attempt has been made to verify the information on
            this web site and the product being sold, neither the product owners
            , distributors, agents or publishers assume any responsibility for
            any error, inaccuracies, and or omissions or assume any
            responsibility or liability whatsoever on behalf of any purchaser or
            reader of these materials. Any slight on people, organisations,
            companies or products are unintentional. The income statements and
            examples on this website are not intended to represent or guarantee
            that everyone will achieve the same results. Each individual’s
            success will be determined by his or her desire, dedication, effort
            and motivation to work and follow the program. There is no guarantee
            or duplicate results stated here. You recognise any business
            endeavour has inherent risk for loss of capital. <br />
            ✔ Dental Care Dental Care and those participating in the event make
            no express or implied claims that you will make money as a result of
            following their advice and/or purchasing their services or products.{' '}
            <br />
            ✔ Dental Care Dental Care is not engaged in rendering legal,
            accounting, professional or other advice or services. <br />
            ✔ By purchasing this service you hereby agree to never engage in a
            chain marketing scheme, to never send unsolicited commercial Email,
            or engage in unfair or deceptive marketing practices of any kind.{' '}
            <br />
            ✔ The service offered on this web site is for educational and
            information purposes only. Check with your lawyer, accountant, or
            other professional advisor before using this information. <br />
            ✔ You agree that Dental Care Dental Care, Presenters and/or
            Affiliates are not responsible for any success or failure that you
            or your business may experience as a result of any information
            presented or any products or services offered at the Event. <br />
            ✔ You freely and of your own will risk any and all capital you may
            choose to spend implementing concepts outlined while using this
            service.You will do so with skill and common sense. You will not
            hold Dental Care Dental Care, the presenters and / or affiliates
            liable or accountable in any way for any failure of the service to
            live up to your expectations. <br />✔ Your use of and browsing in
            the site and/or purchasing and this service is at your risk. Dental
            Care Dental Care, nor any other party involved in creating,
            producing, or delivering the site is liable for any direct,
            incidental, consequential, indirect, or punitive damages arising out
            of your access to, or use of, the site or service. Without limiting
            the foregoing, everything on the site and included in the service is
            provided to you “as is” without warranty of any kind, either
            expressed or implied, including, but not limited to, the implied
            warranties of Merchantability, fitness for a particular purpose, or
            non-infringement. ✔ Please note that some jurisdictions may not
            allow the exclusion of implied warranties, so some of the above
            exclusions may not apply to you. Check your local laws for any
            restrictions or limitations regarding the exclusion of implied
            warranties.
          </p>
        </div>
        <div className='m-2 p-2'>
          <h2 className='text-xl'>Child Dental Benefits Schedule</h2>
          <p className='mt-3'>
          ✔ Child Dental Benefits Schedule provides dental services, including dental exams, dental X-rays, professional scale and clean, fissure sealants, tooth-coloured fillings, root canal treatment, and tooth removal procedures.

          ✔ The benefits are not available for orthodontic or cosmetic dental services and can’t be used for services provided in a hospital.

          ✔ Take advantage of the $1,026 benefit to pay for your child’s dental services for 2 years.

          ✔ If the funds aren’t fully used up during the first year, you can still use them for the next year.

          ✔ After the 2nd year, any outstanding balance will not be carried to the next year.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
